import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/expense-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/ExpenseForm';
import { IExpense } from 'src/types/expense';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { IProvider } from '../../../../../../types/provider';
import { QueryParams } from '../../../../../../types/grid';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    expense: IExpense | null;
    inProgress: boolean;
    providers: Paginated<IProvider>;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getProviders: (params: QueryParams) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ExpenseEditScreen: FC<Props> = (props: Props) => {
    const {
        expense,
        inProgress,
        match: {
            params: { id },
        },
        getData,
    } = props;
    useEffect(() => {
        props.getProviders({
            page: 1,
            itemsPerPage: 9000,
        });
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (!expense || expense.id !== id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData, id]);

    if (!expense || inProgress) {
        return <Loader />;
    }

    const { providers } = props;
    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'EXPENSES', path: routes.EXPENSES_LIST },
                    { name: `EDIT ${expense?.id ? expense?.id : ''}`, path: '' },
                ]}
            />

            <div className={classNames(styles.editWrap)}>
                <Form
                    providers={providers.list}
                    initialValues={{
                        ...expense,
                        providerDropDown: { value: expense.provider?.id, label: `${expense.provider?.fullName}` },
                    }}
                />
            </div>
        </RoleLayout>
    );
};
export default ExpenseEditScreen;
